import { type ReactNode } from 'react';

import StepScreen from '@/karehero-app/access/StepScreen';
import FactList from '@/karehero-app/tell-us-once/intake/FactList';
import {
  DOCUMENTS_READ,
  FROM_LETTER,
} from '@/karehero-app/tell-us-once/benefits/BenefitsCalculator.content';

// PROPOSED. What the paperwork answered, read back before the questions start
// rather than after they finish.
//
// The review used to sit at the end, which made handing something over an act
// of faith: you sent a letter, answered everything anyway, and only saw what it
// had told us once there was nothing left to save. Here it is the payoff for
// the screen before it — this is what you no longer have to answer.
//
// The intake's own fact rows, not a list of its own. A fact we read out of a
// document is the same object here as it is in the profile, sparkle and all,
// and it is corrected the same way.
const DocumentsReadScreen = ({
  onContinue,
  bar,
}: {
  onContinue?: () => void;
  /** The calculator's app bar. Omit and the screen has none. */
  bar?: ReactNode;
}) => (
  <StepScreen
    bar={bar}
    title={DOCUMENTS_READ.title}
    description={DOCUMENTS_READ.description}
    primaryLabel={DOCUMENTS_READ.primary}
    onPrimary={() => onContinue?.()}
  >
    <FactList groups={[{ label: FROM_LETTER.label, rows: FROM_LETTER.rows }]} />
  </StepScreen>
);

export default DocumentsReadScreen;
